import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const [errors, setErrors] = useState({});
    const [statusMessage, setStatusMessage] = useState(""); // For feedback message
    const [captchaValid, setCaptchaValid] = useState(false); // Store reCAPTCHA validity

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) {
            newErrors.name = "Name is required";
        } else if (formData.name.length < 2) {
            newErrors.name = "Name must be at least 2 characters long";
        }
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email address";
        }
        if (!formData.message) {
            newErrors.message = "Message is required";
        } else if (formData.message.length < 10) {
            newErrors.message = "Message must be at least 10 characters long";
        }
        if (!formData.phone) {
            newErrors.phone = "Phone number is required";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = "Invalid phone number";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValid(!!value); // If the CAPTCHA is filled out, set to true
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Check if form is valid and CAPTCHA is solved
        if (validateForm() && captchaValid) {
            console.log("Form submitted successfully", formData);
            
            // Clear any previous status message
            setStatusMessage("");
    
            try {
                // Send form data to the server using fetch
                const response = await fetch('/send-email', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData), // Send the formData, including phone
                });
    
                // Log the entire response to understand the data
                console.log("Response Status:", response.status);
                console.log("Response Body:", await response.text());
    
                // Check if the response is OK (status code 2xx)
                if (!response.ok) {
                    throw new Error(`Server error: ${response.statusText}`);
                }
    
                setStatusMessage("Your message has been sent successfully. We'll get back to you soon!");
    
                // Clear the form after successful submission
                setFormData({
                    name: "",
                    email: "",
                    message: "",
                    phone: "", // Reset phone field too
                });
    
            } catch (error) {
                console.error("Error sending email:", error);
                // Show error message
                setStatusMessage("There was an error sending your message. Please try again.");
            }
        } else {
            setStatusMessage("Please complete the CAPTCHA.");
        }
    };

    return (
        <>
<div class="tf-page-title">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center ">
                            <h4 className='breadcrumbtitle'>Contact Us</h4>
                            <div className=' breadcrumb'>
                                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                                <h6>Contact Us</h6></div>
                        </div>
                    </div>
                </div>

            </div>

            <section className="flat-spacing-21">
                <div className="container">
                    <div className="tf-grid-layout gap30 lg-col-2">
                        <div className="tf-content-left">
                            <h5 className="mb_20" style={{fontFamily:"Raleway, serif"}}>Visit Our Store</h5>
                            <div className="mb_20">
                                <p className="mb_15"><strong>Address</strong></p>
                                <p>#29, 1st Floor BTM 2nd stage, <br/>Bannerghatta main road, opposite to Gopalan mall, <br/>Next jayadeva metro station, Bangalore - 560076</p>
                            </div>
                            <div className="mb_20">
                                <p className="mb_15"><strong>Phone</strong></p>
                                <p><a style={{color:"black"}} href="tel:+919620072626">+91 9620072626</a></p>
                            </div>
                            <div className="mb_20">
                                <p className="mb_15"><strong>Email</strong></p>
                                <p> <a style={{color:"black"}} href="mailto:support@royalhood.in">support@royalhood.in</a></p>

                            </div>
                            <div className="mb_36">
                                <p className="mb_15"><strong>Open Time</strong></p>

                                <p>Every day 11am to 9pm</p>
                            </div>
                        </div>
                        <div className="tf-content-right">
                            <h5 className="mb_20" style={{fontFamily:"Raleway, serif"}}>Let's Connect.....</h5>
                            <div>
                                <form className="form-contact" onSubmit={handleSubmit}>
                                    <div className="d-flex gap-15 mb_15">
                                        <fieldset className="w-100">
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                placeholder="Name *"
                                            />
                                            {errors.name && <p className="error-text">{errors.name}</p>}
                                        </fieldset>
                                        <fieldset className="w-100">
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                placeholder="Email *"
                                            />
                                            {errors.email && <p className="error-text">{errors.email}</p>}
                                        </fieldset>
                                        <fieldset className="w-100">
                                            <input
                                                type="number"
                                                name="phone"
                                                id="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                placeholder="Phone *"
                                                required
                                            />
                                            {errors.phone && <p className="error-text">{errors.phone}</p>}
                                        </fieldset>
                                    </div>
                                    <div className="mb_15">
                                        <textarea
                                            placeholder="Message"
                                            name="message"
                                            id="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            cols="30"
                                            rows="10"
                                        ></textarea>
                                        {errors.message && <p className="error-text">{errors.message}</p>}
                                    </div>
                                    <div className="mb_15">
                                        {/* Google reCAPTCHA */}
                                        <ReCAPTCHA
                                            sitekey="6LeT2ZIqAAAAAE8px5Uy95G1C4gd26JuYvPXatP9"  // Replace with your reCAPTCHA site key
                                            onChange={handleCaptchaChange}
                                        />
                                    </div>
                                    <div className="send-wrap">
                                        <button
                                            type="submit"
                                            className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center"
                                        >
                                            Send
                                        </button>
                                    </div>
                                </form>
                                {statusMessage && (
                                    <div>
                                        <p>{statusMessage}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="w-100">
                <iframe
                    // src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d343.7286030177302!2d77.5664425495329!3d12.917667960399093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU1JzAzLjYiTiA3N8KwMzQnMDAuMSJF!5e0!3m2!1sen!2sin!4v1733392323292!5m2!1sen!2sin"
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3108.3450617507733!2d77.59814235062444!3d12.915122120770874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU0JzUzLjQiTiA3N8KwMzYnMDAuNCJF!5e1!3m2!1sen!2sin!4v1734960080643!5m2!1sen!2sin"
                    width="100%"
                    height="646"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
        </>
    );
};

export default ContactUs;
